import { Link } from "react-router-dom";

interface BrandHeaderProps {
  /** Optional right-side element — nav links, a user badge, etc. */
  right?: React.ReactNode;
  /** When set, the logo is not a link (useful during exam attempt page). */
  static?: boolean;
}

/**
 * Site-wide branded header. Renders the logo from /logo.png (place your file at
 * src/OTA.Web/public/logo.png). Falls back to a text mark if the image is missing.
 */
export function BrandHeader({ right, static: isStatic }: BrandHeaderProps) {
  const logo = (
    <img
      src="/logo.png"
      alt="Baba Farid Group of Institutions"
      className="h-12 w-auto sm:h-14"
      onError={(e) => {
        // Graceful fallback if /logo.png is missing.
        const img = e.currentTarget;
        img.style.display = "none";
        const fallback = document.createElement("div");
        fallback.className = "text-lg font-bold text-brand";
        fallback.textContent = "Online Test Assessment";
        img.parentElement?.appendChild(fallback);
      }}
    />
  );

  return (
    <header className="sticky top-0 z-20 border-b border-brand-ink/10 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
        {isStatic ? logo : <Link to="/" aria-label="Home">{logo}</Link>}
        {right && <div className="flex items-center gap-3 text-sm">{right}</div>}
      </div>
    </header>
  );
}
